import { IResourceComponentsProps } from '@pankod/refine-core';
import { getJobById } from 'apis/job';
import { useCallback, useEffect, useState } from 'react';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { useParams } from 'react-router-dom';
import { formatDateTime } from 'utils';

export const JobEdit: React.FC<IResourceComponentsProps> = () => {
    const { id } = useParams();
    const [job, setJob] = useState<any>();
    const handleGetJobById = useCallback(async (id) => {
        const res = await getJobById(id);
        setJob(res?.data);
    }, []);

    useEffect(() => {
        if (id) {
            handleGetJobById(id);
        }
    }, [handleGetJobById, id]);

    return (
        <div style={{ marginTop: '20px' }}>
            <p style={{ fontWeight: 600, fontSize: '14px', color: '#000' }}>Total track: {job?.length || 0}</p>
            <p style={{ fontWeight: 600, fontSize: '14px', color: '#000' }}>Job detail:</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '35px' }}>
                <p style={{ width: '14%', fontWeight: 500, color: '#000' }}>Date</p>
                <p style={{ width: '14%', fontWeight: 500, color: '#000' }}>Country</p>
                <p style={{ width: '14%', fontWeight: 500, color: '#000' }}>Label</p>
                <p style={{ width: '58%', fontWeight: 500, color: '#000' }}>Title</p>
            </div>
            {(job || []).map((item: any, index: any) => {
                return (
                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <p style={{ width: '14%' }}>{formatDateTime(item?.createdAt)}</p>
                        <p style={{ width: '14%' }}>{item?.country}</p>
                        <p style={{ width: '14%' }}>{item?.label?.name}</p>
                        <p style={{ width: '58%' }}>{item?.track?.title}</p>
                    </div>
                );
            })}
        </div>
    );
};
